import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    value: {
      type: String,
      default: '*'
    }
  },
  data: function data() {
    var year = new Date().getFullYear();
    return {
      type: '1',
      // 类型
      cycle: {
        // 周期
        start: year,
        end: year
      },
      loop: {
        // 循环
        start: 0,
        end: 0
      },
      week: {
        // 指定周
        start: 0,
        end: 0
      },
      work: 0,
      last: 0,
      appoint: [] // 指定

    };
  },
  computed: {
    value_: function value_() {
      var result = [];

      switch (this.type) {
        case '1':
          // 每秒
          result.push('*');
          break;

        case '2':
          // 年期
          result.push("".concat(this.cycle.start, "-").concat(this.cycle.end));
          break;

        case '3':
          // 循环
          result.push("".concat(this.loop.start, "/").concat(this.loop.end));
          break;

        case '4':
          // 指定
          result.push(this.appoint.join(','));
          break;

        case '6':
          // 最后
          result.push("".concat(this.last === 0 ? '' : this.last, "L"));
          break;

        default:
          // 不指定
          result.push('?');
          break;
      }

      ;
      this.$emit('input', result.join(''));
      return result.join('');
    }
  },
  watch: {
    'value': function value(a, b) {
      this.updateVal();
    }
  },
  methods: {
    updateVal: function updateVal() {
      if (!this.value) {
        return;
      }

      if (this.value === '?') {
        this.type = '5';
      } else if (this.value.indexOf('-') !== -1) {
        // 2周期
        if (this.value.split('-').length === 2) {
          this.type = '2';
          this.cycle.start = this.value.split('-')[0];
          this.cycle.end = this.value.split('-')[1];
        }
      } else if (this.value.indexOf('/') !== -1) {
        // 3循环
        if (this.value.split('/').length === 2) {
          this.type = '3';
          this.loop.start = this.value.split('/')[0];
          this.loop.end = this.value.split('/')[1];
        }
      } else if (this.value.indexOf('*') !== -1) {
        // 1每
        this.type = '1';
      } else if (this.value.indexOf('L') !== -1) {
        // 6最后
        this.type = '6';
        this.last = this.value.replace('L', '');
      } else if (this.value.indexOf('#') !== -1) {
        // 7指定周
        if (this.value.split('#').length === 2) {
          this.type = '7';
          this.week.start = this.value.split('#')[0];
          this.week.end = this.value.split('#')[1];
        }
      } else if (this.value.indexOf('W') !== -1) {
        // 8工作日
        this.type = '8';
        this.work = this.value.replace('W', '');
      } else {
        // *
        this.type = '4';
        this.appoint = this.value.split(',');
      }
    }
  },
  created: function created() {
    this.updateVal();
  }
};